<template>
    <div class="cronometro" :id="'cronometro'+idpedido">
        <p>{{ tempoRestante }}</p>
    </div>
</template>

<script>
export default {
    name: "Contador",
    props: {
        datahorainicio: {
            type: String,
            required: true,
        },
        datahorariolimite: {
            type: String,
            required: true,
        },
        idpedido: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tempoRestante: "",
            intervalId: null,
        };
    },
    methods: {
        calcularTempoRestante() {
            const agora = new Date();
            const limite = new Date(this.datahorariolimite);

            const diferenca = limite - agora;

            if (diferenca <= 0) {
                this.tempoRestante = "00:00:00";
                clearInterval(this.intervalId);
                document.getElementById('cronometro'+this.idpedido).style.backgroundColor = "red"; // Muda a cor de fundo para vermelho quando o tempo acabar
                return;
            }

            const horas = String(Math.floor(diferenca / (1000 * 60 * 60))).padStart(2, "0");
            const minutos = String(Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
            const segundos = String(Math.floor((diferenca % (1000 * 60)) / 1000)).padStart(2, "0");

            this.tempoRestante = `${horas}:${minutos}:${segundos}`;
        },
    },
    mounted() {
        this.calcularTempoRestante();
        this.intervalId = setInterval(this.calcularTempoRestante, 1000);
    },
    beforeDestroy() {
        clearInterval(this.intervalId);
    },
};
</script>

<style scoped>
.cronometro {
    width: 100px;
    height: 30px;
    background-color: blue;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    border-radius: 5px;
    padding-top: 15px;
    margin-right: 10px;
}
</style>